import React, { useEffect, useState } from "react";
import { fetchApi } from "../../helper/api";
import { IsAlert } from "../atoms/IsAlert";
const $ = require("jquery");
$.Datatable = require("datatables.net");

class ContentListIPC extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      data: null,
    };
  }
  componentDidMount() {
    this.getdata(function () {});
  }
  getdata = async () => {
    var req = await fetchApi("api/Ipc/" + this.props.id, "GET", true);
    var res = await req.json();
    this.setState({ data: res.data }, function () {
      this.setDatatable();
    });
  };
  setDatatable = () => {
    var self = this;
    this.$el = $(this.el);
    this.$el.DataTable({
      bLengthChange: false,
      bInfo: true,
      language: { searchPlaceholder: "Search...", search: "" },
      bDestroy: true,
      data: this.state.data,
      columns: [
        {
          width: 20,
          title: "No.",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return meta.row + 1;
          },
        },
        {
          title: "Serial Number",
          className: "options",
          data: null,
          render: function (data, type, full, meta) {
            return data.serialNumber;
          },
        },
      ],
    });

    $(".lihaDetail").click(function (e) {
      e.preventDefault();
      // self.props.router.push("/on-boarding/calon-agen/123/data-calon-agen")
    });
    $(".deleteData").click(function (e) {
      e.preventDefault();
      IsAlert.fire({
        title: "",
        text: "Apakah anda yakin untuk menghapus?",
        icon: "warning",
        showCancelButton: false,
        focusConfirm: true,
        confirmButtonText: "OK",
      }).then(function (isConfirm) {
        if (isConfirm.isConfirmed) {
          // navigate("/login")
        }
      });
    });
    var anu = $(".dataTables_filter");
    $(".wadah").html(anu);
  };
  render() {
    return (
      <table
        id="dataCalonAgen"
        className="display table w-100"
        width="100%"
        ref={(el) => (this.el = el)}
      ></table>
    );
  }
}

export default ContentListIPC;
